@use "@konova/styles/styles";

.root {
  --info-box--background: var(--info-box--color--ultra-light);
  --info-box--color: var(--info-box--color--main);
  --info-box--paddings: var(--theme--tokens--info-box--padding, var(--theme--sizing--1x) var(--theme--sizing--15x));

  &.isCentered {
    .wrapper {
      align-items: center;
    }
  }

  &.isSticky {
    position: sticky;
    bottom: 80px;
    z-index: calc(var(--theme--index--layer--content) + 1);
    max-width: styles.$layout-container-width-small;
    background: var(--theme--tokens--body--background);
    box-shadow: var(--theme--shadow--md);

    @include styles.mq("min", "small") {
      max-width: styles.$layout-container-width-medium;
    }
    @include styles.mq("min", "medium") {
      max-width: styles.$layout-container-width-lg;
    }

    @include styles.mq("min", "large") {
      max-width: styles.$layout-container-width-xl;
    }
  }

  &.isStatic {
    position: fixed;
    bottom: 80px;
    z-index: calc(var(--theme--index--layer--content) + 1);
    max-width: styles.$layout-container-width-small;
    background: var(--theme--tokens--body--background);
    box-shadow: var(--theme--shadow--md);

    @include styles.mq("min", "small") {
      max-width: styles.$layout-container-width-medium;
    }
    @include styles.mq("min", "medium") {
      max-width: styles.$layout-container-width-lg;
    }

    @include styles.mq("min", "large") {
      max-width: styles.$layout-container-width-xl;
    }
  }

  &.hasIcon {
    .wrapper {
      grid-template-areas: "prefix content suffix";
      grid-template-columns: 24px 1fr max-content;

      @include styles.mq("max", "small") {
        grid-template-areas:
          "prefix content"
          "prefix suffix";
        grid-template-columns: 32px auto;
      }
    }
  }

  &.linkFormatting {
    a:not([role="button"]):not([class*="button-component"]) {
      text-decoration: underline;
      color: var(--info-box--color);

      &:hover,
      &:focus-visible {
        color: var(--info-box--color--dark);
      }
    }
  }

  & {
    width: 100%;
    border-radius: var(--theme--tokens--info-box--radius, 4px);
    overflow: hidden;
  }

  .wrapper {
    background: var(--info-box--background);
    color: var(--info-box--color);
    box-sizing: border-box;
    display: grid;
    grid-template-areas: "content suffix";
    grid-template-columns: 1fr max-content;
    gap: var(--theme--sizing--15x);
    padding: var(--info-box--paddings);
    align-items: flex-start;

    @include styles.mq("max", "small") {
      grid-template-areas:
        "content"
        "suffix";
      grid-template-columns: auto;
    }
  }

  .suffix {
    grid-area: suffix;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .children {
    grid-area: content;
    overflow: hidden;
  }

  .prefix {
    grid-area: prefix;
    padding-top: 2px;
  }

  .icon {
    width: var(--theme--sizing--25x);
    height: var(--theme--sizing--25x);
  }

  .closeBtnWrapper {
    height: 24px;
  }

  .closeBtn {
    position: relative;
    top: -2px;
  }

  .actions {
    margin-top: var(--theme--sizing--2x);
    grid-area: suffix;

    &:empty {
      display: none;
    }
  }
}
